import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import '../../styles/navigation/AdminHeader.css';
import jidduLogo from '../../../images/Logo/JidduFilms_Logo_White.png';
// import LanguageSelector from './LanguageSelectorAdmin';
// import ThemeToggleAdmin from './ThemeToggleAdmin';

const HeaderAdmin = ({ userLogout }) => {
  // const [isDarkMode, setIsDarkMode] = useState(false);
  // const [currentLanguage, setCurrentLanguage] = useState('English');

  /*
  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  const switchLanguage = (language) => {
    setCurrentLanguage(language);
    
  };
  */
  return (
    <header className="admin-header">
      <div className="admin-header-logo">
        <a href="/">
          <img 
            src={jidduLogo} 
            alt="Jiddu Films" 
            className="admin-header__logo-img"
          />
        </a>
      </div>
      <div className="admin-header-actions">
        {/* 
        <LanguageSelector currentLanguage={currentLanguage} switchLanguage={switchLanguage} />
        <ThemeToggleAdmin isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        */}
        <button onClick={userLogout} aria-label="Logout">
          <FontAwesomeIcon icon={faSignOutAlt} /> Logout
        </button>
      </div>
    </header>
  );
};

export default HeaderAdmin;